import React from 'react';
import SADropdown from '../../common/dropdown/SADropdown';
import {withAuthorizationV2} from '../../../services/Authorization';
import Time from '../../../services/Time';
import {useIntl} from "react-intl";

const AvailabilityEnd = ({availabilities, error, onDateChange, onTimeChange, selectedDates, serviceDuration}) => {
  const intl = useIntl();

  const [availableEndDates, setAvailableEndDates] = React.useState([]);
  const [availableEndTimes, setAvailableEndTimes] = React.useState([]);

  React.useEffect(() => {
      setAvailableEndDates(computeAvailableEndDates());
      setAvailableEndTimes(computeAvailableEndTimes());
    }, []
  );

  React.useEffect(() => {
      // if start date changed, recompute date and time slots + check that current end date and end time are not in the past
      const newAvailableEndDates = computeAvailableEndDates();
      const newAvailableEndTimes = computeAvailableEndTimes();
      setAvailableEndDates(newAvailableEndDates);
      setAvailableEndTimes(newAvailableEndTimes);
      updatePastEndDate(newAvailableEndDates, selectedDates.endDate);
      updatePastEndTime(newAvailableEndTimes, selectedDates.endTime, selectedDates.startTime, serviceDuration);
    }, [selectedDates.startDate]
  );

  React.useEffect(() => {
      // if start time changed or end date changed, recompute time slots + check that current end time is not in the past
      const newAvailableEndTimes = computeAvailableEndTimes();
      setAvailableEndTimes(newAvailableEndTimes);
      updatePastEndTime(newAvailableEndTimes, selectedDates.endTime, selectedDates.startTime, serviceDuration);
    }, [selectedDates.startTime, selectedDates.endDate]
  );

  const computeAvailableEndDates = () => {
    const availableEndDates = availabilities.map(availability => availability.day).filter(day => day >= selectedDates.startDate);
    if (!availableEndDates.includes(selectedDates.endDate) && selectedDates.endDate >= selectedDates.startDate) {
      availableEndDates.push(selectedDates.endDate);
    }
    return availableEndDates.sort();
  }

  const computeAvailableEndTimes = (updatedEndDate) => {
    updatedEndDate = updatedEndDate || selectedDates.endDate;
    const availableEndTimes = (availabilities.find(a => a.day === updatedEndDate) || {slots: []})
      .slots
      .filter(slot => selectedDates.startDate !== updatedEndDate || slot >= selectedDates.startTime)
    return availableEndTimes.sort();
  }

  const updatePastEndDate = (newAvailableEndDates, endDate) => {
    if (newAvailableEndDates.includes(endDate)) {
      return endDate;
    }
    // select first available end date
    onDateChange({
      target: {
        name: 'endDate',
        value: newAvailableEndDates[0]
      }
    });
    return newAvailableEndDates[0];
  }

  const updatePastEndTime = (newAvailableEndTimes, endTime, startTime, serviceDuration) => {
    if (newAvailableEndTimes.includes(endTime)) {
      return;
    }
    // select start date + service duration of last available end time of the day
    const defaultEndDate = Time.stringToMoment(startTime, "HH:mm:ss") // convert start time to moment
      .add(Time.stringToDuration(serviceDuration)) // add the service duration
      .format("HH:mm:ss") // format to end date format
    onTimeChange({
      target: {
        name: 'endTime',
        value: newAvailableEndTimes.find(endTime => endTime === defaultEndDate) || newAvailableEndTimes[newAvailableEndTimes.length - 1]
      }
    });
  }

  return (
    <div className="form-field row">
      <ul className="list col-md-5 col-xxl-5 ">
        <label>{intl.formatMessage({id: 'placeholder.endDate'})}</label>
        <SADropdown name="endDate" value={selectedDates.endDate}
                    choices={availableEndDates.map(d => ({value: d, display: Time.dateFromApiToDisplay(d)}))} onChange={onDateChange}
                    error={error}/>
      </ul>
      <ul className="list col-md-5 col-xxl-5 ">
        <label>{intl.formatMessage({id: 'placeholder.endTime'})}</label>
        <SADropdown name="endTime" value={selectedDates.endTime}
                    choices={availableEndTimes.map(t => ({value: t, display: Time.timeFromApiToDisplay(t)}))} onChange={onTimeChange}
                    error={error}/>
      </ul>
    </div>
  )

}

export default withAuthorizationV2(AvailabilityEnd, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
